'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_style2.default);

var Tag = function Tag(_ref) {
  var children = _ref.children,
      appearance = _ref.appearance,
      selected = _ref.selected,
      value = _ref.value,
      onClick = _ref.onClick,
      disabled = _ref.disabled;
  return _react2.default.createElement(
    'div',
    {
      className: cx('xsui-tag', 'xsui-tag--appearance-' + appearance, selected && 'xsui-tag--selected', disabled && 'xsui-tag--disabled'),
      'data-value': value,
      onClick: onClick },
    _react2.default.createElement(
      'div',
      { className: cx('xsui-tag__label') },
      children
    ),
    onClick && _react2.default.createElement(
      'div',
      { className: cx('xsui-tag__trigger') },
      _react2.default.createElement(_icon2.default, { name: 'remove-circle', size: 20 })
    )
  );
};

Tag.propTypes = {
  children: _propTypes2.default.any.isRequired,
  appearance: _propTypes2.default.oneOf(['primary', 'secondary']),
  disabled: _propTypes2.default.bool,
  selected: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  value: _propTypes2.default.any
};

Tag.defaultProps = {
  appearance: 'primary',
  disabled: false,
  selected: false
};

exports.default = Tag;